<template>
  <div class="videoArea">
    <div class="viewport">
      <div class="playerTitle">课程名称：{{ viewInfo.coureTitle }}</div>
      <div class="palyerBox">
        <div class="prism-player" id="player-con"></div>
      </div>
    </div>
    <div class="viewlist">
      <p class="tit">相关视频</p>
      <ul class="videolist">
        <template v-for="(item, index) in viewList">
          <li class="wrap_li" :key="index" @click="switchVideo(index, item.videoId, item.isPerchase)">
            <img :src="pic + item.avatar" draggable="false" />
            <div class="liMsg">
              <p :class="{ active: index == mark }">{{ item.title }}</p>
              <div>
                <img src="../../assets/img/play.png" draggable="false" />
                {{ item.watchNum }}
              </div>
            </div>
          </li>
        </template>
      </ul>
      <div class="buySet" v-show="isBuySet || false">
        <p>
          合集：
          <span class="prePirce">{{ viewInfo.price }}</span>
          <span class="oriPirce">{{ viewInfo.preprice }}</span>
        </p>
        <div class="buyBtn" @click="isShow = true">购买合集</div>
      </div>
    </div>
    <PopUpWin :isPop.sync="isShow" :tipWord="tips" :codeUrl="wxurl" @closePop="(isShow = false), (num = -1)" />
  </div>
</template>

<script>
import PopUpWin from "../Common/PopUpWin";
let devPlayer = null;
export default {
  name: "PlayerArea",
  props: ["isBuySet", "videoGid", "videoId", "viewList", "viewInfo", "wxurl"],
  data() {
    return {
      unionId: "",
      isShow: false,
      isPerchase: false,
      mark: 0,
      pic: "https://www.orthoday.com/SDpic/common/picSelect?gid=",
      player: null,
      timer: null,
      tips: "微信扫码购买视频课程",
      vId: "",
      dataTimer: null,

      playTimer: null,
      timeRange: null,
      // 弹窗提示语
      num: -1,
      popupTipArr: [
        { title: "您未登录，请登录后继续观看！", isShow: false, to: "/login" },
        { title: "您尚未认证，请认证后继续观看！", isShow: false, to: "/user" },
        { title: "您尚未购买该课程，请购买后继续观看！", isShow: true, to: "" },
        { title: "当前视频需要开通会员才能继续观看!", isShow: true, to: "" },
      ],
    };
  },
  components: { PopUpWin },
  watch: {
    videoId: function (nv, ov) {
      this.vId = nv;
      this.getKeyInfo(nv, true);
    },
    viewInfo: {
      handler(val) {
        this.viewInfo = val;
        this.isPerchase = this.viewInfo.isPerchase;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    loopAdddData() {
      this.dataTimer = setInterval(() => {
        this.addData();
      }, 1000 * 60);
    },
    addData() {
      let param = this.$route.params.gid || this.$route.query.gid;
      let gid = param || this.isBuySet ? sessionStorage.getItem("c-gid") : sessionStorage.getItem("v-gid");

      let headers = {
        equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
        phoneModel: "", //手机型号
        appVersionNumber: "", //app版本号
      };

      console.log("this.timeRange", this.timeRange)
      this.$axios
        .post(
          "/SD/dataVideo/addData",
          this.$qs.stringify({
            watchTime: Math.floor(this.timeRange / 1000), //观看时长
            courseGid: this.isBuySet ? gid : '', // 直播ID/慕课ID
            videoGid: this.isBuySet ? this.videoGid : gid  , // 慕课下的小节ID，如果为直播那么为空
            courseType: this.isBuySet ? "1" : "2", // 1:幕课 2：视频3：直播
            lastTime: Math.floor(devPlayer.getCurrentTime()), // 观看到多少秒（直播没有就为空）
            videoNum: "", //观看视频第几个 （直播没有就为空）
            equipmentType: "2", // 设备类型1：H5 2：PC 3：APP
          }),
          {
            headers,
          }
        )
        .then((res) => {
          this.timeRange = 0;
        });
    },
    changePlayer(dt) {
      devPlayer.dispose();
      this.initPlayer(dt);
    },
    getKeyInfo(videoId, flag) {
      this.$axios
        .post(
          "/web/securityToken/getSecurityToken",
          this.$qs.stringify({ videoId })
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 1) {
            let dt = data.result_data;
            flag ? this.initPlayer(dt) : this.changePlayer(dt);
          } else {
            this.$message.error(data.message);
          }
        })
        .catch((err) => {
        });
    },
    initPlayer(data) {

      document.getElementById("player-con").innerHTML = "";
      let _this = this,
        token = localStorage.getItem("token"),
        userId = localStorage.getItem("userId"),
        isConfirm = localStorage.getItem("isConfirm"),
        isPerchase = this.isPerchase;
      devPlayer = new Aliplayer(
        {
          id: "player-con",
          format: "m3u8",
          mute:true,
          autoplay:false,
          width: "100%",
          height: "450px",
          playsinline: true,
          preload: true,
          encryptType: 1,
          controlBarVisibility: "always",
          useH5Prism: true,
          skinLayout: [
            { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
            { name: "H5Loading", align: "cc" },
            { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
            { name: "infoDisplay" },
            { name: "tooltip", align: "blabs", x: 0, y: 56 },
            { name: "thumbnail" },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                { name: "volume", align: "tr", x: 5, y: 10 },
              ],
            },
          ],
          // MPS
          vid: data.videoId,
          accId: data.accessKeyId,
          accSecret: data.accessKeySecret,
          stsToken: data.securityToken,
          domainRegion: "cn-beijing",
          authInfo:
            '{"ExpireTime": "' +
            data.expireTime +
            '","MediaId": "' +
            data.videoId +
            '","Signature": "' +
            data.signature +
            '"}',
        },
        function (player) {
          _this.loopAdddData();

          // player.play();

          let clear = () => {
            if (_this.timer) {
              clearTimeout(_this.timer);
              _this.timer = null;
            }
          };

          let getTimes = () => {
            _this.timer = setTimeout(getTimes, 1000);
          };

          player.on("ready", function (e) {
            clear();
            getTimes();
            player.on("timeupdate", function (currentTime) {
              // 播放进度更新
              handlePlayer();
            });
            player.on("play", function (e) {
              console.log('play')
              // getTimes();
              clear();
              if (_this.playTimer) clearInterval(_this.playTimer);
              _this.playTimer = setInterval(() => {
                _this.timeRange += 1000;
              }, 1000);
            });
            player.on("pause", function (e) {
              clearInterval(_this.playTimer);
              clear();
            });
            player.on("ended", function (e) {
              clear();
            });
            player.on("error", function (e) {
              clear();
            });
          });
          function handlePlayer() {
            if (player.getCurrentTime() > 60) {

              if (token == null || userId == null || _this.viewInfo.logined) {
                handleAlert(0);
              } else if (isConfirm == 0) {
                handleAlert(1);
              } else if (
                _this.viewInfo.isVip == false &&
                _this.viewInfo.isPerchase == false &&
                _this.viewInfo.isPrice == true &&
                _this.viewList[_this.mark].isPerchase == false &&
                _this.viewList[_this.mark].price != 0
              ) {
                if (_this.viewInfo.newold === "0") {
                  handleAlert(2);
                } else {
                  handleAlert(3);
                }
              }
            }
          }
          function handleAlert(n) {
            player.seek(60);
            player.pause();
            if (_this.num === n) {
              return;
            }
            _this.num = n;
            _this
              .$alert(_this.popupTipArr[n].title, "提示信息", {
                showClose: false,
                type: "warning",
              })
              .then(() => {
                sessionStorage.setItem("RedirectPage", true);
                if (_this.popupTipArr[n].isShow) {
                  _this.isShow = true;
                } else {
                  _this.$router.push(_this.popupTipArr[n].to);
                }
              });
          }
        }
      );
    },
    switchVideo(index, videoId, isPerchase) {
      this.mark = index;
      this.getKeyInfo(videoId);
      // this.isPerchase = isPerchase == undefined ? true : isPerchase;
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    let play = devPlayer,
      len = Object.keys(play);
    if (!len) return false;
    play.dispose();
    clearInterval(this.playTimer);
    clearInterval(this.dataTimer);
    devPlayer = null;
    this.player = null
  },
};
</script>

<style scoped src="../../assets/css/player-area.css"></style>